<script>
import { onMount } from 'svelte';
	import { fly } from 'svelte/transition';
	import { cubicOut } from 'svelte/easing';

	// import textfit from 'textfit';

	import Icons from '../components/icons.svelte';
	import TeamListPlayer from './team-list-player.svelte';

	import { STATUSES, TEAMS, ACTIONS } from '../utils/constants';

	export let players = [];
	export let team;
	export let numPlayersRequired;
	export let cardsRemaining;

	$: finalNumPlayersRequired = numPlayersRequired || 0;
	$: playerGiver = players.find(player => player.team === team && player.isGiver);
	$: playersFiltered = players.filter(player => player.team === team && !player.isGiver);
	$: dummies = Array(Math.max(finalNumPlayersRequired / 2 - playersFiltered.length, 0)).fill(null).map((d, i) => ({ id: i, name: '', team, isDummy: true }));
	$: playersWithDummies = playersFiltered.concat(dummies);
</script>

{#if cardsRemaining}
	<span
		class="score {team}"
		title="Number of cards remaining"
		transition:fly={{ x: -500, duration: 600, easing: cubicOut, delay: 400 }}>
			{cardsRemaining}
	</span>
{/if}

<section class="guessers">
	{#each playersWithDummies as player, i (player.id)}
	<TeamListPlayer {...player} />
	{/each}
</section>

{#if playerGiver}
<div class="speaker-container">
	<Icons
		name="volume"
		size="2.5em"
		animateDraw="false"
		strokeColor="white"
		cycleStrokeColor={playerGiver.isTurn} />
</div>

<div class="giver">
	<TeamListPlayer {...playerGiver} />
</div>
{/if}

<style lang="less">
	.guessers {
		display: inline-block;
		width: 100%;
		padding: 0.75em;
		overflow-x: hidden;
		overflow-y: auto;
	}

	.speaker-container {
		display: inline-block;
		text-align: center;
		transform: rotate(-90deg);
	}

	.giver {
		display: inline-block;
		padding: 0.5em 0;
	}

	.score {
		display: inline-block;
		width: 2em; height: 2em;
		margin: 0.5em 0;
		font-size: 1.5em;
		line-height: 1.9em;
		border: 0.1em solid white;
		border-radius: 50%;
		background: white;
		color: black;

		&.one {
			color: white;
			background: rgba(30,130,255);
		}

		&.two {
			color: white;
			background: rgba(255,0,204);
		}
	}
</style>